import GeoPoint from '@/models/Shared/GeoPoint';
import AgencyBrandThemeMode from '@/models/Agencies/AgencyBrandThemeMode';

export default class CreateAgencyRequest {
	registeredName = '';  
    brandName = '';  
	brandPrimaryColour = '';
    brandThemeMode: AgencyBrandThemeMode = AgencyBrandThemeMode.Dark;
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint;       			
	taxNumber = '';          			
	registrationNumber = ''; 
	website = '';      
    termsAndConditionsUrl = '';
    healthAndSafetyPolicyUrl = '';      			
	biography = '';   			
}